import type { FaireProductEntity } from "../../entity_types/product";

export const p_zyqrxg5ksw: FaireProductEntity = {
  token: "p_zyqrxg5ksw",
  type: "product",
  name: "KARTA - Classic Clog Mule, Suede, Gold Hardware",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl: "https://cdn.faire.com/fastly/e9d9ff777a5441f13b61399ddef16b355c4019be156d8800d1f9806b2248e240.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/923cf130e91a78bc6c7f5b8f7584c98d3024f10532f5ce2fe0b8fd2391f92295.jpeg",
    "https://cdn.faire.com/fastly/b61eee1ef6ba7bf82daad59b2f52426e726fdb99240244635c1223aaf4576056.jpeg",
    "https://cdn.faire.com/fastly/0c36dafa7238287ebd259bf1bb3efdbcc2d26470fbe86ec42cbe7ea65e1ffa62.jpeg",
    "https://cdn.faire.com/fastly/d06c0b29e71010f776c05d8af91220941c88d6f523e5e52ffc38a3774500b3ef.jpeg",
    "https://cdn.faire.com/fastly/b09e1bf3f769ef0f1c48b0d0ea68fd4f1778cbb7931e1e07cb6377effb56a843.jpeg",
    "https://cdn.faire.com/fastly/430c8e44a57fe75ab73e3f01b05e9adfb10c2f574bc0da40f46ee4efac90a7c3.jpeg"
  ],
  priceDollars: 13.5,
  description: "KARTA is a classic mule with a sleek double-buckle design and a soft suede-like finish. Available in black, chocolate, and taupe, this versatile slip-on blends comfort with a polished edge, making it an easy go-to for both laid-back and dressed-up looks.\n\n𝐎𝐎𝐓𝐃:\nPair the black version with straight-leg jeans and a boxy blazer for a clean, everyday look. The chocolate shade works effortlessly with cream trousers and a chunky knit for a warm, autumn vibe. For the taupe, style with wide-leg linen pants and a crisp white shirt for an airy, neutral palette that feels effortlessly elevated.\n\n• Slip On Clog Mule\n• Double Strap Buckle\n• Suede Upper\n• Colors: Black, Chocolate, Taupe",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:08.400Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
